import { Form, Modal } from 'antd';
import { memo, useEffect, useRef, useState } from 'react';
import { Subscription } from 'rxjs';
import { BaseInput, BaseModalAction } from 'src/libraries';
import AccountService from 'src/services/account.service';
import { useAccount } from 'src/stores';
import { MESSAGE } from 'src/utils';
import { EventBusName, IBaseEventPayload } from 'src/utils/event-bus';
import EventBus from 'src/utils/event-bus/event-bus';

const sv = new AccountService();

function ModalProfile() {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const subscriptions = useRef<any>();
  const { account, changeAccount } = useAccount();

  useEffect(() => {
    registerEventBus();

    return () => {
      unregisterEventBus();
    };
  }, []);

  const registerEventBus = () => {
    subscriptions.current = new Subscription();
    subscriptions.current.add(
      EventBus.getInstance().events.subscribe((data: IBaseEventPayload<any>) => {
        data.type === EventBusName.SHOW_MODAL_PROFILE && setOpen(true);
      }),
    );
  };

  const unregisterEventBus = () => {
    subscriptions.current?.unsubscribe();
  };

  const onCancel = () => {
    setOpen(false);
  };

  const onFinish = async (values: any) => {
    if (loading) return;
    setLoading(true);
    try {
      await sv.updateProfile({ fullname: values.fullname, phone: values.phone });
      account && changeAccount({ ...account, fullname: values.fullname, phone: values.phone });
      MESSAGE.success('Thay đổi thông tin cá nhân thành công!');
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    open &&
      account &&
      form.setFieldsValue({
        fullname: account.fullname,
        email: account.email,
        phone: account.phone,
      });
  }, [open]);

  return (
    <Modal onCancel={onCancel} width="30vw" open={open} footer={null} title="Thông tin cá nhân" maskClosable={false}>
      <Form onFinish={onFinish} layout="vertical" form={form}>
        <BaseInput name="fullname" label="Họ và tên" span={24} required rule={{ required: true }} />
        <BaseInput name="email" label="Email" span={24} disabled required rule={{ required: true }} />
        <BaseInput name="phone" label="Số điện thoại" span={24} />

        <BaseModalAction onCancel={onCancel} loading={loading} />
      </Form>
    </Modal>
  );
}

export default memo(ModalProfile);
